import isPlaceholder from "./isPlaceholder";
import isLoading from "./isLoading";
import isLoadingFailed from "./isLoadingFailed";

export default ({ itemState, variants }) => {
  if (
    isPlaceholder({ itemState }) ||
    isLoading({ itemState }) ||
    isLoadingFailed({ itemState }) ||
    !variants
  ) {
    return false;
  }

  return true;
};
